import type { ChangeEvent, ComponentPropsWithoutRef } from "react";
import { Combobox } from "@headlessui/react";
import classNames from "classnames";

export interface InputProps<T = unknown>
  extends ComponentPropsWithoutRef<"input"> {
  displayValue: (value: T) => string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Input = <T,>({
  displayValue,
  onChange,
  className,
  ...rest
}: InputProps<T>) => (
  <Combobox.Input
    className={classNames(
      "bg-primary text-dark w-full cursor-pointer rounded-lg border-none py-2.5 pl-4 pr-10 text-base focus:ring-0 disabled:cursor-not-allowed disabled:opacity-40",
      className,
    )}
    displayValue={displayValue}
    onChange={onChange}
    {...rest}
  />
);
